export const LOGIN_ADMIN = "/login-admin";
export const HOME = "/admin/home";
export const USERS = "/admin/users";
export const EDIT_USER = "/admin/edit-user/:id";

